<template>
    <rkm-row>
        <rkm-col cols="12">
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-alert
                        v-if="item.isAtendimentoIdoso"
                        color="success"
                        class="mb-2"
                    >
                        <rkm-row>
                            <rkm-col cols="12">
                                <strong>Acompanhamento do idoso</strong>
                            </rkm-col>
                        </rkm-row>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxAntecedente :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxSubjetivo :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxObjetivo :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxAvaliacao :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxPlano :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxFinalizacao :item="item" />
                </rkm-col>
            </rkm-row>
        </rkm-col>
    </rkm-row>
</template>

<script>
// Components.
import BoxAntecedente from './components/antecedente/Index'
import BoxAvaliacao from './components/avaliacao/Index'
import BoxFinalizacao from './components/finalizacao/Index'
import BoxObjetivo from './components/objetivo/Index'
import BoxPlano from './components/plano/Index'
import BoxSubjetivo from './components/subjetivo/Index'

export default {
    components: {
        BoxAntecedente,
        BoxAvaliacao,
        BoxFinalizacao,
        BoxObjetivo,
        BoxPlano,
        BoxSubjetivo,
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>